import { createFileRoute } from "@tanstack/react-router"
import { CompanyServiceDetailPage } from "@/features/companies/company-service-detail-page"
export const Route = createFileRoute("/_authenticated/companies/$companyId/services/$serviceId")({
    component: RouteComponent,
})
function RouteComponent() {
    const { serviceId } = Route.useParams()
    return <CompanyServiceDetailPage serviceId={serviceId} />
}
